// Tiny auth helper — the admin frontend has no logged-in vs logged-out
// complexity beyond "is there a non-expired admin JWT in localStorage". We
// optimistically trust the token's exp claim for the navigation guard and let
// the API enforce real validity on every call (401 -> automatic logout via
// axiosInstance).
import { jwtDecode } from 'jwt-decode';
import { STORAGE_TOKEN_KEY, STORAGE_EMAIL_KEY } from '../config';

export function getStoredToken() {
    return localStorage.getItem(STORAGE_TOKEN_KEY);
}

export function getStoredEmail() {
    return localStorage.getItem(STORAGE_EMAIL_KEY);
}

export function setSession(token, email) {
    localStorage.setItem(STORAGE_TOKEN_KEY, token);
    if (email) localStorage.setItem(STORAGE_EMAIL_KEY, email);
}

export function clearSession() {
    localStorage.removeItem(STORAGE_TOKEN_KEY);
    localStorage.removeItem(STORAGE_EMAIL_KEY);
}

export function isAuthenticated() {
    const token = getStoredToken();
    if (!token) return false;
    try {
        const payload = jwtDecode(token);
        if (payload.exp && payload.exp * 1000 < Date.now()) return false;
        if (payload.role !== 'super_admin') return false;
        return true;
    } catch (e) {
        return false;
    }
}
